<div class="m2-container-default">
	<div class="product-dialog-container" *ngIf="productItem">
		<!-- Header with close button -->
		<div class="dialog-header-custom">
			<h1 class="product-title">{{ productItem.Name }}</h1>
			<button mat-icon-button mat-dialog-close class="close-btn">
				<mat-icon>close</mat-icon>
			</button>
		</div>

		<!-- Product category and SKU -->
		<div class="product-meta">
			<span class="category"
				>{{ productItem.ParentCategoryName }} | {{ productItem.CategoryName }}</span
			>
			<span class="sku">SKU: {{ productItem.Id }}</span>
		</div>

		<!-- Material Tab Group -->
		<mat-tab-group class="product-tabs" animationDuration="300ms">
			<mat-tab label="Product Details">
				<div class="tab-content">
					<div class="product-image-container">
						<img
							[src]="productItem.ImageUrl || '/assets/images/default-product.jpg'"
							[alt]="productItem.Name"
							class="product-image"
						/>
					</div>

					<div class="product-description-section">
						<h3>Product Description:</h3>
						<p class="description-text">{{ productItem.Description }}</p>
					</div>

					<div class="product-tags-section">
						<h3>Tags</h3>
						<div class="tags-container">
							<mat-chip-listbox>
								<mat-chip *ngFor="let tag of productTags" selected>
									{{ tag }}
								</mat-chip>
							</mat-chip-listbox>
						</div>
					</div>
				</div>
			</mat-tab>

			<mat-tab label="Pricing">
				<div class="tab-content">
					<product-pricing-view [productItem]="productItem"></product-pricing-view>
				</div>
			</mat-tab>

			<mat-tab label="UOM">
				<div class="tab-content">
					<product-uom-view [productItem]="productItem"></product-uom-view>
				</div>
			</mat-tab>

			<mat-tab label="Availability">
				<div class="tab-content">
					<product-availability-view
						[productItem]="productItem"
					></product-availability-view>
				</div>
			</mat-tab>
		</mat-tab-group>
	</div>

	<!-- Action buttons -->
	<mat-dialog-actions class="dialog-actions" *ngIf="productItem">
		<button mat-button color="warn" (click)="onRemove()" class="remove-btn">
			<mat-icon>delete</mat-icon>
			Remove Item
		</button>
		<div class="spacer"></div>
		<button
			mat-flat-button
			color="primary"
			(click)="onEdit()"
			class="edit-btn"
		>
			<mat-icon>edit</mat-icon>
			Edit
		</button>
	</mat-dialog-actions>

	<!-- Empty state -->
	<div *ngIf="!productItem" class="empty-state">
		<mat-icon class="empty-icon">error_outline</mat-icon>
		<h3>Product not found</h3>
		<p>The requested product could not be loaded.</p>
	</div>
</div>
